import { render, staticRenderFns } from "./RejectEntryComponent.vue?vue&type=template&id=25161d46&"
import script from "./RejectEntryComponent.vue?vue&type=script&lang=ts&"
export * from "./RejectEntryComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports